//Helpers
import { convertToUnit } from 'src/helpers/units_helpers';
import { translateTemplateTitle } from '../template_helpers';
//Types
import type { VirtualComponentInterfaceData, VCInterfaceStatus } from 'src/types/VirtualComponents';

export const updateWindowCoverStatus = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
): void => {
	let hideLabel = true;
	const { role, vcType, config } = data;
	if (role === 'position') {
		data.icon = `fas fa-blinds${valueData.value > 0 ? '-raised' : ''}`;
		data.unit = '%';
		data.step = config?.meta?.ui?.step;
		hideLabel = false;
	} else if (role === 'open') {
		data.icon = 'fa fa-arrow-up';
	} else if (role === 'stop') {
		data.icon = 'fa fa-pause';
	} else if (role === 'close') {
		data.icon = 'fa fa-arrow-down';
	}
	if (vcType === 'button' || vcType === null || valueData?.value !== null) {
		interface_data.push({
			...data,
			hasAction: true,
			value:
				role === 'status'
					? valueData.value
					: translateTemplateTitle(valueData.label) ||
						(vcType === 'button' ? null : convertToUnit(valueData.value, valueData.unit)),
			event: valueData.event !== null ? valueData.event : valueData.value,
			hideLabel,
		});
	}
};
